module.exports = __webpack_public_path__ + "static/media/favicon.4e0530d6.png";